exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".size-selector[data-v-27cae4c1] {\n  width: 40px;\n  height: 40px;\n}\n.size-selector[data-v-27cae4c1]:hover, .size-selector[data-v-27cae4c1]:focus {\n  border-width: 2px;\n}\n.size-selector.active[data-v-27cae4c1] {\n  border-color: #a6a6a6;\n  border-width: 2px;\n  color: #a6a6a6;\n}\n.size-selector[data-v-27cae4c1]:disabled {\n  border-color: #e0e0e0;\n  color: #e0e0e0;\n  cursor: not-allowed;\n}\n.size-selector[data-v-27cae4c1]:disabled:hover, .size-selector[data-v-27cae4c1]:disabled:after {\n  border-width: 1px;\n}\n", ""]);

// exports
